import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, money } from "../../lib/api";

const STATUSES = ["awaiting_payment", "submitted", "paid", "cancelled"];

const OrderRow = ({ o, onSaved }) => {
  const [status, setStatus] = useState(o.status);
  const [delivery, setDelivery] = useState(o.delivery || "");
  const save = async () => {
    try { await api.patch(`/admin/orders/${o.ref}`, { status, delivery }); toast.success("Order updated"); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid={`admin-order-${o.ref}`} className="space-y-3 rounded-2xl border border-white/[0.07] bg-[#1a1633] p-5">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <div className="font-display uppercase text-white">{o.product_title} × {o.quantity}</div>
        <div className="font-display text-white">{money(o.total)} <span className="text-sm text-zinc-400">via {o.coin}</span></div>
      </div>
      {o.telegram && <a href={`https://t.me/${o.telegram.replace("@", "")}`} target="_blank" rel="noreferrer" data-testid={`order-telegram-${o.ref}`} className="inline-block text-base font-medium text-sky-300 hover:text-white">Telegram: {o.telegram}</a>}
      <div className="text-sm text-zinc-400">{new Date(o.created_at).toLocaleString()} · ref <span className="font-mono">{o.ref}</span></div>
      <div className="break-all font-mono text-xs text-zinc-300">TX: {o.tx_hash || "—"}</div>
      <textarea data-testid={`order-delivery-input-${o.ref}`} value={delivery} onChange={(e) => setDelivery(e.target.value)} rows={2} placeholder="Code / delivery shown to the customer when paid" className="field text-sm" />
      <div className="flex gap-3">
        <select data-testid={`order-status-select-${o.ref}`} value={status} onChange={(e) => setStatus(e.target.value)} className="field max-w-[220px] text-sm">
          {STATUSES.map((s) => <option key={s} value={s} className="bg-[#1a1633]">{s.replace("_", " ")}</option>)}
        </select>
        <button onClick={save} data-testid={`order-save-${o.ref}`} className="btn-primary">Save</button>
      </div>
    </div>
  );
};

export const OrdersAdmin = () => {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/admin/orders").then((r) => setOrders(Array.isArray(r.data) ? r.data : []));
  useEffect(() => { load(); }, []);
  if (!orders.length) return <p className="text-zinc-400" data-testid="no-orders">No orders yet.</p>;
  return <div className="space-y-4">{orders.map((o) => <OrderRow key={o.ref} o={o} onSaved={load} />)}</div>;
};
